angular.module('rjmNg.directives').directive "dataWarehouse", [
  () ->
    restrict: "E"
    templateUrl: "settings/directive.dataWarehouse.html"
    replace: true
    scope: {}
    controllerAs: "view"
    require: "^?rjmUi"
    bindToController: true
    controller: [
      "$rootScope"
      "$location"
      "remoteDBConnectionService"
      "notification"
      "emailNotificationService"
      "email"
      "errorConstants"
      "dataWarehouse"
      "$timeout"
      "logger"
      "$window"
      "Columns"
      "app"
      "StructureCache"
      "dataWarehouseTablePath"
      "$routeParams"
      "$modal"
      "FilterSets"
      "replicationService"
      "ConnectionMeta"
      "appRoute"
      "jobService"
      "jobTypes"
      "Tables"
      (
        $rootScope
        $location
        remoteDBConnectionService
        notification
        emailNotificationService
        email
        errorConstants
        dataWarehouse
        $timeout
        logger
        $window
        Columns
        app
        StructureCache
        dataWarehouseTablePath
        $routeParams
        $modal
        FilterSets
        replicationService
        ConnectionMeta
        appRoute
        jobService
        jobTypes
        Tables
      ) ->

        view = @

        ADDITION_TO_NOTIFICATION = if app.hasFeatureFlag('PERSISTENT_VIEWS') then "and Data Warehouse Views " else ""

        if not app.canAccessDataWarehouse()
          console.error "Access to DataWarehouse page is disabled for this client."
          $location.path appRoute("/settings/personal")
          return

        view.canAccessDataWarehouse = app.canAccessDataWarehouse()
        view.loading = true
        view.activeLocalTable = null

        # Kick off a request for structure and reference information for the
        # column builder so the user doesn't have to wait as long when opening the
        # column editor. Also, kick off a request for filter sets.
        StructureCache.getStructureAndReferences()
        FilterSets.get(app.getClientId())
        ConnectionMetaInstance = ConnectionMeta(app.getClientId())

        view.editingColumn = false

        view.viewState = dataWarehouse.VIEW.CHOOSE_TABLE

        view.activeLocalTableName = null

        _restoreActiveLocalTableName = () ->
          view.activeLocalTableName = view.activeLocalTable?.name
          return

        $rootScope.$on '$locationChangeStart', (event, newState, oldState) ->
          _confirmNavigation event

        _views = []

        _isPristine = () ->
          tablePristine = not view.active?.state?.pristine? or view.active.state.pristine
          columnEditorPristine = not view.active?.state?.cePristine? or view.active.state.cePristine
          return tablePristine and columnEditorPristine

        _confirmNavigation = (event) ->
          if not _isPristine()
            if not confirm "Leaving this page will discard your current changes.\n\nDiscard your current changes?"
              event?.preventDefault()
              return false
            else
              # We need this here so that when we're in another portion of the app, we don't continue listening
              # and confirming.
              # Additionally, the only time this can be set, is if we're loading another table (clean state),
              # or are not on the page (clean state)
              view.active.state.pristine = true
              view.active.state.cePristine = true
          return true

        $window.onbeforeunload = () ->
          if not _isPristine()
            return "Leaving this page will discard your current changes."

        _refreshStructure = () ->
          StructureCache.getStructureAndReferences(true)

        _loadColumns = (activeTable, syncState) ->
          syncState.dataPreview =
            display: false
            text: ""

          if _isTracked(activeTable)
            columnsResult = Columns.query
              tid: activeTable.localTableId
              state: ["active"]
            , true
            columnsResult.then (localColumns) =>
              for column in localColumns
                if column.is_in_serving_layer
                  syncState.dataPreview.display = true
              if not syncState.dataPreview.display
                syncState.dataPreview.text = "Pending Update: No Data to Preview at the Moment"
            , (error) ->
              notification.error("", errorConstants.SERVER_ERROR_MESSAGE, "data-warehouse-notifications")
              syncState.dataPreview.text = "A Server Error Occurred: No Data to Preview at the Moment"
          else
            syncState.dataPreview.text = "No Data to Preview"

          view.viewState = dataWarehouse.VIEW.COLUMNS

        _updateActiveTable = (rsConnectionId, databaseName, rsTable, totalTrackedRows) ->
          view.loading = false

          activeTable = angular.copy(rsTable)

          syncState =
            synced: false
            hasColumns: false
            pristine: true
            cePristine: true

          if rsTable.isView
            # if the table is not a view we call out to the remoteDBConnectionService.queryTable
            # this in turn causes a scope rerender when the promise resolves
            # this in turn causes a scope.watch to be reran against the table
            # without the timeout this watch will never fire the necessary number of times on a page
            # reload
            $timeout(() ->
              activeTable.localTableId = activeTable.id
              activeTable.schema = 'emptySchema'
              activeTable.database = 'persistentview'
              activeTable.databaseName = 'persistent_view'
              activeTable.connectionId = 'views'
              activeTable.replicator =
                type: 'persistent_view'
              syncState.synced = activeTable.localTableId
              syncState.hasColumns = true

              dataWarehouseTablePath.updateTablePath activeTable.id
              activeTable.localTableId = activeTable.id
              _updateActiveLocalTable(activeTable.localTableId)
              _loadColumns(activeTable, syncState)
            , 0)
          else
            remoteDBConnectionService.queryTable(rsConnectionId, databaseName, rsTable.schema, rsTable.name)
            .then (result) ->

              if result.columns? && result.columns.length > 0
                activeTable.localTableId = remoteDBConnectionService.getLocalTableId(result.columns)
                activeTable.remoteStructures = result.columns
                syncState.hasColumns = true
              else
                notification.error "", "This table has no columns.", "data-warehouse-notifications"

              syncState.synced = activeTable.localTableId

              dataWarehouseTablePath.updateTablePath activeTable.localTableId

              activeTable.database = databaseName
              activeTable.rsConnectionId = rsConnectionId
              _updateActiveLocalTable(activeTable.localTableId)
              _loadColumns(activeTable, syncState)

            .catch (error) ->
              adBlockErrorMessage = "Your browser prevented us from loading the
                columns for this table. This is often caused due to browser
                plugins that block ads. Please try disabling ad blockers and reloading
                the page."
              notification.error("", adBlockErrorMessage, "data-warehouse-notifications")

          # Wait until the model is fully built before adding it to the scope so
          # controllers $watching it won't trigger too early.
          view.active =
            table: activeTable
            state: syncState
          view.totalTrackedRows = totalTrackedRows

        # Run this whenever we change tables
        _cacheConnectionInfo = () ->
          _updateActiveLocalTable()
          if not view.active.table.isView
            ConnectionMetaInstance.get(view.active.table.connectionId)

        # Update local table
        _updateActiveLocalTable = (id) ->
          if id?
            if _views[id]?
              view.activeLocalTable = _views[id]
              view.activeLocalTable.isView = true
              _restoreActiveLocalTableName()
            else
              StructureCache.getStructure().then (structure) ->
                view.activeLocalTable = structure.getTable(id)
                _restoreActiveLocalTableName()
              _cacheConnectionInfo()
          else
            view.activeLocalTable = null
            _restoreActiveLocalTableName()

        $rootScope.$on 'dataWarehouse.rsTableActivated', (event, rsConnectionId, databaseName, rsTable, totalTrackedRows, views) ->
          _views = views
          if _confirmNavigation()
            _updateActiveTable(rsConnectionId, databaseName, rsTable, totalTrackedRows)

        _tablePreviewRefresh = () ->
          $timeout () ->
            $rootScope.$broadcast 'tablePreviewRefresh'
          , 0

        _updateDerivativeColumns = () ->
          _refreshStructure()
          # view tables will not receive newly created / deleted derivative columns from theses functions
          # setting forceUpdate causes the table fire the view.watch 'table' in columnListDirective which
          # then calls Columns.query receiving the updated columns
          view.active.table.forceUpdate = moment().format("X")
          _updateActiveTable(view.active.table.rsConnectionId, view.active.table.database, view.active.table, view.totalTrackedRows)
          _tablePreviewRefresh()

        $rootScope.$on 'columnEditorSave', () ->
          # Update the inspection report
          if app.hasFeatureFlag('RJQL_SERVICE_CLIENT')
            notification.success("", "Saved Successfully! Column is ready for use.", "data-warehouse-notifications", "", 5)
          else
            notification.success("", "Saved Successfully! Column will be populated after next full update cycle.", "data-warehouse-notifications", "", 5)
          _updateDerivativeColumns()

        $rootScope.$on 'derivativeColumnsDropped', () ->
          _updateDerivativeColumns()

        _isTracked = (table) ->
          return table.localTableId isnt 0

        # This is useful when we need to ask the preview table to redraw itself
        view.tablePreviewRedraw = () ->
          $timeout () ->
            $rootScope.$broadcast 'tablePreviewRedraw'
          , 0

        $rootScope.$on 'dataWarehouse.columnSyncChanged', (event, activeTable) ->
          remoteDBConnectionService.queryTable(
            activeTable.rsConnectionId
            activeTable.database
            activeTable.schema
            activeTable.name
          ).then (result) ->

            if result.columns? && result.columns.length > 0
              activeTable.remoteStructures = result.columns
              activeTable.localTableId = result.columns[0].localTableId

          .catch (error) ->
            notification.error("", errorConstants.SERVER_ERROR_MESSAGE, "data-warehouse-notifications")

        $rootScope.$on 'showColumnEditor', () ->
          view.viewState = dataWarehouse.VIEW.COLUMNS
          view.tablePreviewRedraw()

        $rootScope.$on 'dropTable', () ->
          view.viewState = dataWarehouse.VIEW.COLUMNS

        view.addColumn = () ->
          $rootScope.$broadcast 'createColumn'

        view.dropTable = () ->
          $rootScope.$broadcast 'dropTable'

        view.setTableName = () ->
          if not view.activeLocalTableName? or
            view.activeLocalTableName.length is 0 or
            view.activeLocalTableName.length > 255
              _restoreActiveLocalTableName()
          else if view.activeLocalTable.name.toLowerCase() is view.activeLocalTableName.toLowerCase()
            return
          else
            Tables.setName(view.activeLocalTable, view.activeLocalTableName).then(
              (savedTable) ->
                view.activeLocalTableName = savedTable.name
                view.activeLocalTable.name = savedTable.name
                StructureCache.getStructure(true)
                notification.success("", "Success: Table name has been set to <strong>#{savedTable.name}</strong>.", "data-warehouse-notifications", null, 10)
                notification.warning("", "Warning: Any SQL reports #{ADDITION_TO_NOTIFICATION}that used the old table name must now be edited to refer to this new table name.", "data-warehouse-notifications", null, 20)
              , (error) ->
                view.activeLocalTableName = view.activeLocalTable.name
                if error.errorMessage?
                  notification.error("", "Error: #{error.errorMessage}", "data-warehouse-notifications", null, 10)
                else
                  notification.error("", "Error: There was a problem setting table name. Please try again or contact support", "data-warehouse-notifications", null, 10)
            )

        view.syncTable = (tableId) ->
          workload =
            tableId: tableId
            interruptRunningSync: false
          successSync = () ->
            notification.success "", "We have queued a background sync for this table", "data-warehouse-notifications"
          failSync = () ->
            notification.error "", "We were unable to queue a background sync. Please try again or contact support.", "data-warehouse-notifications"
          # Request an email to the user when the background sync starts and completes
          emailNotificationService.post(email.TYPE.BACKGROUND_SYNC_START)
          emailNotificationService.post(email.TYPE.BACKGROUND_SYNC_COMPLETION)
          jobService(jobTypes.BACKGROUND_DATA_SYNC).queue(workload, successSync, failSync)

        view.getReplicationTypeName = () ->
          replicationService.getFriendlyName(view.activeLocalTable.replicator.type)

        view.getFriendlyDbName = (name) ->
          if name is 'userpush' then 'File Uploads'
          else if name is 'persistentview' then 'Data Warehouse Views'
          else name

        view.rawExport = () ->
          exportScope = $rootScope.$new()
          exportScope.tableItem =
            exportName: "Export for: " + view.active.table.name
            id: view.active.table.localTableId

          logger.log('Data Warehouse Raw Export Usage', 'Open', 1, 'create')

          modal = $modal
            template: 'modal.rawExport.html'
            show: true
            backdrop: 'static'
            scope: exportScope
            modalClass: 'rawExportsModal'
          .then -> #this is here in order to get select2 to work in a modal
            $('.rawExportsModal').removeAttr("tabindex")

        view.canSetReplicationMethod = () ->
          app.hasFeatureFlag('DWM_REPLICATION_OPTIONS') and view.activeLocalTable.replicator.type isnt 'userpush' and not view.activeLocalTable.isView

        view.openReplicationMethodModal = (newTable = false) ->
          replicationMethodScope = $rootScope.$new()
          replicationMethodScope.table = view.activeLocalTable
          replicationMethodScope.newTable = newTable
          conId = view.active.table.connectionId
          replicationMethodScope.connectionId = view.active.table.connectionId
          ConnectionMetaInstance.get(view.active.table.connectionId).then( (result) ->
            replicationMethodScope.remoteDbType = result.meta.connection.type
            logger.log('Replication Modal Usage', 'Open', 1, 'edit')

            modal = $modal
              template: 'modal.replicationMethod.html'
              show: true
              backdrop: 'static'
              scope: replicationMethodScope
              modalClass: 'xLargeModal'
          )

        $rootScope.$on 'initiateNewTable', (event, id) ->
          StructureCache.getStructure(true).then (structure) ->
            view.activeLocalTable = structure.getTable(id)
            _restoreActiveLocalTableName()
            if view.getReplicationTypeName() isnt 'Mongo Subtable'
              view.openReplicationMethodModal(true)

        $rootScope.$on "rawExportQueued", () ->
          listUrl = appRoute("/settings/raw-export")
          notification.clear("data-warehouse-notifications")
          notification.success(
            "",
            "Raw export was successfully queued. Within manage data, the export can be viewed and downloaded from the <a href='#{listUrl}' target='_blank'>Raw Data Export List</a>.",
            "data-warehouse-notifications",
            { dismissable: true, bindHtml: true }
          )

        # Log usage of this page
        # Counting all views as 'edits' for the Data Warehouse page
        logger.log('Data Warehouse Usage', 'Open', 1, 'edit')

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "data-warehouse", scope.view.loading
]
